//  ĐÈN
import taybac from '../img/den/taybac.png';
import hue from '../img/den/hue.png';
import taynguyen from '../img/den/taynguyen.png';
import baclieu from '../img/den/baclieu.png';
import canthoDen from '../img/den/cantho.png';
import dongthapDen from '../img/den/dongthap.png';
import haugiang from '../img/den/haugiang.png';
import longan from '../img/den/longan.png';
import tiengiangDen from '../img/den/tiengiang.png';
import travinhDen from '../img/den/travinh.png';
import vinhlongDen from '../img/den/vinhlong.png';

//  TINH DẦU
import canthoTD from '../img/tinhdau/cantho.png';
import dongthapTD from '../img/tinhdau/dongthap.png';
import nhatrang from '../img/tinhdau/nhatrang.png';
import tiengiangTD from '../img/tinhdau/tiengiang.png';
import travinhTD from '../img/tinhdau/travinh.png';
import vinhlongTD from '../img/tinhdau/vinhlong.png';

export const products = [
  // 🌿 ĐÈN
  {
    id: 1,
    name: 'Đèn Memory Tây Bắc',
    desc: 'Mang cảm hứng núi rừng Tây Bắc với họa tiết thổ cẩm độc đáo.',
    img: taybac,
    type: 'den',
    content: 'Đèn Memory Tây Bắc được chế tác thủ công với hoa văn thổ cẩm đặc trưng, tượng trưng cho vẻ đẹp hùng vĩ của núi rừng Việt Nam. Ánh sáng ấm áp từ đèn giúp không gian trở nên gần gũi và thư giãn.',
    features: ['Thiết kế gốm thủ công', 'Ánh sáng dịu nhẹ', 'Họa tiết thổ cẩm Tây Bắc'],
    origin: 'Lấy cảm hứng từ văn hóa dân tộc vùng Tây Bắc',
    material: 'Gốm tráng men cao cấp, họa tiết khắc tay',
  },
  {
    id: 2,
    name: 'Đèn Memory Huế',
    desc: 'Phản chiếu nét trầm lắng và cổ kính của đất cố đô.',
    img: hue,
    type: 'den',
    content: 'Đèn Memory Huế mang đến cảm giác yên bình và thanh tao. Sắc màu trầm ấm gợi nhớ đến những mái ngói cổ, dòng sông Hương êm đềm.',
    features: ['Phong cách cổ điển', 'Tông màu trầm', 'Phù hợp không gian thiền, phòng ngủ'],
    origin: 'Lấy cảm hứng từ kiến trúc và văn hóa cố đô Huế',
    material: 'Gốm sứ phủ lớp men nâu truyền thống',
  },
  {
    id: 3,
    name: 'Đèn Memory Tây Nguyên',
    desc: 'Ấm áp, mạnh mẽ với hoa văn gốm đặc trưng vùng cao nguyên.',
    img: taynguyen,
    type: 'den',
    content: 'Đèn Memory Tây Nguyên mang vẻ đẹp mạnh mẽ và hoang dã, thể hiện tinh thần tự do và sức sống của núi rừng đại ngàn.',
    features: ['Hoa văn dân tộc Ba Na – Ê Đê', 'Ánh sáng vàng ấm', 'Phù hợp không gian phòng khách, quán cà phê'],
    origin: 'Cảm hứng từ văn hóa cồng chiêng Tây Nguyên',
    material: 'Gốm thô kết hợp sơn mờ chống nhiệt',
  },
  {
    id: 4,
    name: 'Đèn Memory Bạc Liêu',
    desc: 'Tinh tế và duyên dáng, lấy cảm hứng từ vùng đất đờn ca tài tử.',
    img: baclieu,
    type: 'den',
    content: 'Sản phẩm mang nét mềm mại, dịu dàng nhưng vẫn rất sang trọng. Ánh sáng trắng ngà giúp không gian thêm lung linh.',
    features: ['Thiết kế mềm mại', 'Tông trắng sứ thanh nhã', 'Thích hợp làm quà tặng'],
    origin: 'Văn hóa đờn ca tài tử Nam Bộ',
    material: 'Gốm trắng tráng men, chạm nổi hoa văn nhạc cụ',
  },
  {
    id: 5,
    name: 'Đèn Memory Cần Thơ',
    desc: 'Tươi sáng, mang nét bình dị của miền sông nước Tây Đô.',
    img: canthoDen,
    type: 'den',
    content: 'Chiếc đèn thể hiện sự thân thiện và hài hòa của miền sông nước. Ánh sáng vàng kết hợp hương tinh dầu tạo cảm giác thư thái.',
    features: ['Kiểu dáng gọn gàng', 'Ánh sáng vàng ấm', 'Thích hợp không gian sống hiện đại'],
    origin: 'Cảm hứng từ chợ nổi và đời sống sông nước Cần Thơ',
    material: 'Gốm nung, chạm nổi thủ công',
  },
  {
    id: 6,
    name: 'Đèn Memory Đồng Tháp',
    desc: 'Nhẹ nhàng và thanh thoát như những đóa sen hồng Đồng Tháp.',
    img: dongthapDen,
    type: 'den',
    content: 'Lấy cảm hứng từ cánh sen thanh khiết giữa đồng nước mênh mông, Đèn Memory Đồng Tháp tỏa ánh sáng dịu dàng, mang lại không gian yên bình và thư thái. Họa tiết gốm tinh tế phản chiếu vẻ đẹp thanh cao của vùng sen hồng.',
    features: [
      'Thiết kế gốm thủ công với họa tiết hoa sen',
      'Ánh sáng vàng ấm, dễ chịu cho mắt',
      'Kết hợp hài hòa giữa nghệ thuật và thiên nhiên',
    ],
    origin: 'Làng gốm truyền thống Đồng Tháp',
    material: 'Gốm tráng men, dây điện an toàn, bóng đèn LED tiết kiệm năng lượng',
  },
  {
    id: 7,
    name: 'Đèn Memory Hậu Giang',
    desc: 'Phản ánh vẻ đẹp giản dị, ấm áp của miền quê Nam Bộ.',
    img: haugiang,
    type: 'den',
    content: 'Mang trong mình hơi thở của miền quê sông nước, Đèn Memory Hậu Giang mang đến cảm giác gần gũi và thân thuộc. Ánh sáng ấm áp kết hợp với họa tiết gốm dân dã khiến không gian thêm phần yên bình.',
    features: [
      'Tạo không gian ấm cúng, thư giãn',
      'Thích hợp cho phòng ngủ hoặc góc đọc sách',
      'Màu sắc trung tính dễ phối hợp nội thất',
    ],
    origin: 'Hậu Giang – vùng đất hiền hòa miền Tây Nam Bộ',
    material: 'Gốm nung thủ công, sơn phủ chống trầy xước',
  },
  {
    id: 8,
    name: 'Đèn Memory Long An',
    desc: 'Sự kết hợp hài hòa giữa truyền thống và hiện đại.',
    img: longan,
    type: 'den',
    content: 'Đèn Memory Long An mang phong cách tối giản hiện đại nhưng vẫn giữ được nét truyền thống qua đường nét mềm mại và họa tiết gốm tinh xảo. Là lựa chọn lý tưởng cho những ai yêu thích vẻ đẹp trang nhã.',
    features: [
      'Phong cách tối giản nhưng tinh tế',
      'Phù hợp cho không gian hiện đại',
      'Dễ bảo quản và vệ sinh',
    ],
    origin: 'Xưởng gốm Long An – nơi giao thoa văn hóa và sáng tạo',
    material: 'Gốm trắng phủ men mờ, đế gỗ tự nhiên',
  },
  {
    id: 9,
    name: 'Đèn Memory Tiền Giang',
    desc: 'Đậm chất sông nước miệt vườn, mang hơi thở thiên nhiên.',
    img: tiengiangDen,
    type: 'den',
    content: 'Lấy cảm hứng từ những vườn cây trái trù phú của Tiền Giang, mẫu đèn này mang sắc nâu đất nhẹ nhàng và ánh sáng vàng dịu, gợi nhớ không gian bình yên nơi miền quê sông nước.',
    features: [
      'Thiết kế cảm hứng từ vườn cây miệt vườn',
      'Ánh sáng dịu nhẹ, tiết kiệm điện',
      'Thủ công hoàn toàn, mỗi sản phẩm là độc bản',
    ],
    origin: 'Tiền Giang – vùng đất trù phú miền Tây',
    material: 'Gốm nâu tự nhiên, đế tre ép thân thiện môi trường',
  },
  {
    id: 10,
    name: 'Đèn Memory Trà Vinh',
    desc: 'Mang nét giao hòa văn hóa Khmer và Việt, độc đáo và sâu lắng.',
    img: travinhDen,
    type: 'den',
    content: 'Đèn Memory Trà Vinh là sự hòa quyện tinh tế giữa văn hóa Khmer và Việt. Hoa văn khắc nổi mang đậm dấu ấn truyền thống được chiếu sáng bởi ánh đèn vàng ấm, tạo nên không gian sang trọng và cổ điển.',
    features: [
      'Hoa văn khắc nổi thủ công tinh xảo',
      'Ánh sáng vàng ấm, gợi cảm giác yên bình',
      'Phù hợp trang trí phòng khách hoặc thiền phòng',
    ],
    origin: 'Làng gốm Khmer Trà Vinh',
    material: 'Gốm đất nung tự nhiên, phủ men bán bóng',
  },
  {
    id: 11,
    name: 'Đèn Memory Vĩnh Long',
    desc: 'Tươi sáng, đậm chất miền Tây trù phú và thân thiện.',
    img: vinhlongDen,
    type: 'den',
    content: 'Đèn Memory Vĩnh Long mang phong cách tươi sáng và nhẹ nhàng, phản ánh sự hiếu khách, chân chất của con người miền Tây. Sản phẩm phù hợp với mọi không gian sống, tạo điểm nhấn ấm cúng và thanh lịch.',
    features: [
      'Ánh sáng vàng nhẹ, giúp thư giãn thị giác',
      'Thiết kế gốm tròn mềm mại, biểu tượng cho sự đủ đầy',
      'Sản xuất thủ công, thân thiện với môi trường',
    ],
    origin: 'Vĩnh Long – vùng đất của làng nghề gốm nổi tiếng',
    material: 'Gốm truyền thống phủ men trắng ngà, dây điện bọc sợi vải',
  },


  // 🌸 TINH DẦU
  {
    id: 12,
    name: 'Tinh Dầu Cần Thơ',
    desc: 'Hương thơm nhẹ nhàng, giúp thư giãn tinh thần sau ngày dài.',
    img: canthoTD,
    type: 'tinhdau',
    content: 'Tinh dầu Cần Thơ là sự hòa quyện giữa hương hoa đồng nội và trái cây nhiệt đới. Mùi thơm dễ chịu giúp giảm căng thẳng và tạo năng lượng tích cực.',
    features: ['100% thiên nhiên', 'Dùng cho máy xông, đèn xông', 'Giúp thư giãn, khử mùi'],
    origin: 'Chiết xuất từ thảo mộc vùng Đồng bằng sông Cửu Long',
    material: 'Tinh dầu nguyên chất từ vỏ cam, sả chanh, hoa nhài',
  },
  {
    id: 13,
    name: 'Tinh Dầu Đồng Tháp',
    desc: 'Chiết xuất từ sen và thảo mộc, mang hương đồng nội mộc mạc.',
    img: dongthapTD,
    type: 'tinhdau',
    content: 'Hương sen nhẹ nhàng thanh khiết, thích hợp cho không gian thiền hoặc phòng ngủ.',
    features: ['Tinh dầu sen tự nhiên', 'Giúp ngủ ngon', 'Khử mùi ẩm mốc'],
    origin: 'Cánh đồng sen Đồng Tháp Mười',
    material: 'Chiết xuất sen hồng, cam thảo, oải hương',
  },
  {
    id: 14,
    name: 'Tinh Dầu Nha Trang',
    desc: 'Mùi biển dịu mát kết hợp với thảo mộc vùng duyên hải.',
    img: nhatrang,
    type: 'tinhdau',
    content: 'Sản phẩm đem lại cảm giác sảng khoái như làn gió biển buổi sớm, giúp tinh thần phấn chấn hơn mỗi ngày.',
    features: ['Hương biển mát mẻ', 'Giúp tỉnh táo, giảm stress', 'Thích hợp dùng buổi sáng'],
    origin: 'Chiết xuất từ thảo dược vùng duyên hải miền Trung',
    material: 'Bạc hà, hương thảo, muối khoáng tự nhiên',
  },
  {
    id: 15,
    name: 'Tinh Dầu Tiền Giang',
    desc: 'Ngọt ngào và dễ chịu, chiết xuất từ vỏ cam và bưởi miền Tây.',
    img: tiengiangTD,
    type: 'tinhdau',
    content: 'Tinh dầu Tiền Giang mang mùi hương ngọt thanh của cam bưởi chín mọng, kết hợp tinh chất sả chanh giúp thanh lọc không khí, khử mùi và giảm căng thẳng. Mỗi giọt tinh dầu là hương vị của miệt vườn sông nước.',
    features: [
      'Chiết xuất tự nhiên 100%',
      'Giúp giảm stress, làm tươi mới tinh thần',
      'Thích hợp dùng trong phòng khách và nơi làm việc',
    ],
    origin: 'Vỏ cam, bưởi và sả chanh vùng Tiền Giang',
    material: 'Tinh dầu vỏ cam, bưởi, sả chanh ép lạnh nguyên chất',
  },
  {
    id: 16,
    name: 'Tinh Dầu Trà Vinh',
    desc: 'Mùi hương thanh khiết từ sả chanh giúp khử mùi và xua muỗi.',
    img: travinhTD,
    type: 'tinhdau',
    content: 'Hương thơm sả chanh tự nhiên mang lại cảm giác sảng khoái, đồng thời giúp đuổi muỗi và làm sạch không khí. Phù hợp cho gia đình hoặc không gian làm việc cần sự tươi mát.',
    features: [
      'Mùi hương tươi mát, dễ chịu',
      'Khử mùi hiệu quả, xua muỗi tự nhiên',
      'An toàn cho trẻ nhỏ và thú cưng',
    ],
    origin: 'Chiết xuất từ cây sả chanh trồng tại Trà Vinh',
    material: 'Tinh dầu sả chanh nguyên chất, không pha tạp',
  },
  {
    id: 17,
    name: 'Tinh Dầu Vĩnh Long',
    desc: 'Tinh túy từ thiên nhiên, mang lại cảm giác thư giãn sâu.',
    img: vinhlongTD,
    type: 'tinhdau',
    content: 'Tinh dầu Vĩnh Long được pha trộn từ các loại thảo mộc đặc trưng của miền Tây, mang hương thơm nhẹ nhàng, giúp cân bằng cảm xúc và cải thiện giấc ngủ.',
    features: [
      'Hỗ trợ thư giãn và ngủ ngon',
      'Thích hợp dùng trong liệu pháp xông hơi và massage',
      'Tạo cảm giác dễ chịu, giảm lo âu',
    ],
    origin: 'Thảo mộc tự nhiên từ vùng Vĩnh Long trù phú',
    material: 'Tinh dầu oải hương, gỗ đàn hương và cam bergamot',
  },
];

export const findProductById = (id) => products.find((p) => String(p.id) === String(id));


